import BaseService from './baseService';

export default class extends BaseService {
    constructor() {
        super('instanceManager');
    }
    /**
     * Gets list of instances
     * @returns list of instances
     */
    getInstances = () => this.httpGetRequest('instanceList');

    /**
     * Gets projects lookups 
     * @returns list of projects lookups 
     */
    getProjects = () => this.httpGetRequest('projectList');

    /**
     * Stops instance
     * @param {Object} request 
     * @param {string} request.instanceId - instance id
     * @param {boolean} request.isStandAlone - isStandAlone flag
     * @returns void
     */
    stopInstance = (request: { instanceId: string; isStandAlone: boolean; }) => this.httpPostRequest('stopInstance', request);

    /**
     * Starts instance
     * @param {Object} request 
     * @param {string} request.instanceId - instance id
     * @param {boolean} request.isStandAlone - isStandAlone flag
     * @param {number} request.projectId - projectId optional
     * @returns void
     */
    startInstance = (request: { instanceId: string; isStandAlone: boolean; projectId?: number }) => this.httpPostRequest('startInstance', request);
}
